/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Expireddescription1Inputs */

const zh_learn_expireddescription1 = /** @type {(inputs: Learn_Expireddescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请联系创建者延长有效期，或发布一个新的分享链接。`)
};

const en_learn_expireddescription1 = /** @type {(inputs: Learn_Expireddescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask the owner to extend the validity period or publish a new share link.`)
};

const es_learn_expireddescription1 = /** @type {(inputs: Learn_Expireddescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pide al propietario que amplíe el periodo de validez o publique un nuevo enlace.`)
};

/**
* | output |
* | --- |
* | "Ask the owner to extend the validity period or publish a new share link." |
*
* @param {Learn_Expireddescription1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_expireddescription1 = /** @type {((inputs?: Learn_Expireddescription1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Expireddescription1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_expireddescription1(inputs)
	if (locale === "en") return en_learn_expireddescription1(inputs)
	return es_learn_expireddescription1(inputs)
});
export { learn_expireddescription1 as "learn_expiredDescription" }